import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IRestBaseListResponse } from '../models/rest/baseResponse';
import { ParkingBaseCompany, ParkingBaseGarage } from './revenue-control.service';

@Injectable({ providedIn: 'root' })
export class ParkingBaseService {
  constructor(private _httpClient: HttpClient) {}

  getCompanies(url: string, username: string, password: string): Observable<IRestBaseListResponse<ParkingBaseCompany>> {
    return this._httpClient.get<IRestBaseListResponse<ParkingBaseCompany>>('ParkingBase/Company', {
      params: {
        Url: url,
        Username: username,
        Password: password,
      },
    });
  }

  getGarages(
    url: string,
    username: string,
    password: string,
    companyId: string,
  ): Observable<IRestBaseListResponse<ParkingBaseGarage>> {
    return this._httpClient.get<IRestBaseListResponse<ParkingBaseGarage>>('ParkingBase/Garage', {
      params: {
        Url: url,
        Username: username,
        Password: password,
        CompanyId: companyId,
      },
    });
  }
}
